import {GetRecursoPesquisa} from "@localization/siteMap/endpoints/_RecursosEndpoints.js";
import {IRecurso} from "@models/recurso/IRecurso";
import React from "react";
import {DefaultConsumerPesquisaAutoProps, DefaultPesquisaAuto} from "@shared/specialComponents/DefaultPesquisaAuto.tsx";

interface RecursoPesquisaProps extends DefaultConsumerPesquisaAutoProps<IRecurso, { search: string }> {
}

export function RecursoPesquisa(props: RecursoPesquisaProps) {
    const formatar = (recurso: IRecurso) => `${recurso.id} - ${recurso.nome}`;

    return (
        <DefaultPesquisaAuto<IRecurso, { search: string }>
            itemToString={formatar}
            display={{name: 'Recurso'}}
            endpoint={(x) => {
                return GetRecursoPesquisa(x.data.search, x.pagination)
            }}
            searchField={'search'}
            {...props}
        />
    );
}